const ACCESS_KEY = 'smartgaz_access';
const REFRESH_KEY = 'smartgaz_refresh';
const TOKENS_AT_KEY = 'smartgaz_tokens_at';

let memoryAccess = null;

function read(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key, value) {
  try {
    if (value == null || value === '') localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // private mode
  }
}

export const getToken = () => memoryAccess || read(ACCESS_KEY);

export const setToken = (t) => {
  memoryAccess = t || null;
  write(ACCESS_KEY, t);
  if (t) write(TOKENS_AT_KEY, String(Date.now()));
  try {
    window.dispatchEvent(new Event('smartgaz:tokens-updated'));
  } catch {
    // SSR / tests
  }
};

export const getRefreshToken = () => read(REFRESH_KEY);

export const setRefreshToken = (t) => {
  write(REFRESH_KEY, t);
};

export const persistTokens = (accessToken, refreshToken) => {
  if (accessToken) setToken(accessToken);
  if (refreshToken) setRefreshToken(refreshToken);
};

export const clearAllTokens = () => {
  memoryAccess = null;
  write(ACCESS_KEY, null);
  write(REFRESH_KEY, null);
  write(TOKENS_AT_KEY, null);
};

export const getTokensUpdatedAt = () => {
  const n = Number(read(TOKENS_AT_KEY));
  return Number.isFinite(n) ? n : 0;
};
